// extracted by mini-css-extract-plugin
export default {"store":"Store_store__xGHr4","container":"Store_container__tdvH4","store__components":"Store_store__components__lroJI","store__cards":"Store_store__cards__3eZU1"};